import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import intervalPlural from "i18next-intervalplural-postprocessor"; // 處理英文複數的套件

// 翻譯資源檔案
import optionsPanel_ENUS from "./locales/ENUS/optionsPanel.json"; // 專案中的翻譯檔位置
import optionsPanel_JAJP from "./locales/JAJP/optionsPanel.json";
import optionsPanel_THTH from "./locales/THTH/optionsPanel.json";
import optionsPanel_ZHCN from "./locales/ZHCN/optionsPanel.json";
import optionsPanel_ZHTW from "./locales/ZHTW/optionsPanel.json";
import optionsPanel_KOKR from "./locales/KOKR/optionsPanel.json";

const resources = {
  ENUS: {
    optionsPanel: optionsPanel_ENUS,
    // seo: seo_ENUS
  },
  JAJP: {
    optionsPanel: optionsPanel_JAJP,
  },
  THTH: {
    optionsPanel: optionsPanel_THTH,
  },
  ZHCN: {
    optionsPanel: optionsPanel_ZHCN,
  },
  ZHTW: {
    optionsPanel: optionsPanel_ZHTW,
  },
  // 香港語系翻譯檔與台灣相同
  ZHHK: {
    optionsPanel: optionsPanel_ZHTW,
  },
  KOKR: {
    optionsPanel: optionsPanel_KOKR,
  }
}

// 初始化 i18next
i18n.use(initReactI18next).use(intervalPlural).init({
    resources,
    lng: "ZHTW", // 預設語言
    fallbackLng: "ENUS", // 如果當前切換的語言沒有對應的翻譯則使用這個語言
    ns: ['optionsPanel'], // 語系裡要 loading 的 namespace TODO: 之後有SEO頁在此新增
    defaultNS: 'optionsPanel',  // 預設的 namespace name
    interpolation: {
      escapeValue: false // 不進行轉義處理
    }
})

export default i18n;